/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APICategoryRequest
 */
export interface APICategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof APICategoryRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APICategoryRequest interface.
 */
export function instanceOfAPICategoryRequest(value: object): value is APICategoryRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APICategoryRequestFromJSON(json: any): APICategoryRequest {
    return APICategoryRequestFromJSONTyped(json, false);
}

export function APICategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function APICategoryRequestToJSON(value?: APICategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

